module.exports = __webpack_public_path__ + "img/flashlight_w.5d85881e.svg";